import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
  headers: { "Content-Type": "application/json" },
});

// Optional: handle 401 globally
api.interceptors.response.use(
  (r) => r,
  async (error) => {
    return Promise.reject(error);
  }
);

export default api;

export function formatApiError(err) {
  if (!err) return "Unknown error";
  const detail = err.response?.data?.detail;
  if (detail == null) return err.message || "Unknown error";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e?.msg ? e.msg : JSON.stringify(e))).join(", ");
  if (detail?.msg) return detail.msg;
  return String(detail);
}
